import type { Media } from '../../types/props'

export interface WhyChooseItem {
  title: string
  desc: string
  img: Media
}

export interface WhyChooseProps {
  data: {
    productData: WhyChooseItem[]
  }
  className?: string
}
